import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { theme } from "../../../foundations/theme.es.js";
import useIsMobile from "../../../hooks/use-is-mobile.es.js";
import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import { memo } from "react";
import MuiCard from "../../../../node_modules/@mui/material/Card/Card.es.js";
import { NONE_OPTION } from "../../../foundations/constants.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { BorderRadius } from "../../../foundations/border-radius.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Wrapping } from "../../../foundations/wrapping.es.js";
const DEFAULT_CARD_BORDER = `1px solid ${theme.palette.border.main}`;
const CustomCard = styled(MuiCard, styledOptions)(function getCustomCardStyle({
  isMobile,
  maxWidth
}) {
  const selectedPadding = isMobile ? Spacing["1000"] : Spacing["1500"];
  return {
    maxWidth,
    borderRadius: BorderRadius.paper,
    boxShadow: NONE_OPTION,
    paddingLeft: selectedPadding,
    paddingRight: selectedPadding,
    paddingTop: selectedPadding,
    paddingBottom: selectedPadding,
    backgroundColor: theme.palette.background.paper,
    border: DEFAULT_CARD_BORDER,
    display: Displaying.flex,
    justifyContent: Alignment.flexStart,
    flexWrap: Wrapping.wrap,
    gap: Spacing["3000"]
  };
});
function CustomCardComponent({
  isMobile,
  ...rest
}) {
  const isCurrentlyMobile = useIsMobile();
  return /* @__PURE__ */ jsx(CustomCard, { isMobile: isMobile ?? isCurrentlyMobile, ...rest });
}
const DualGridCardLayourWrapper = memo(CustomCardComponent);
export {
  DualGridCardLayourWrapper
};
//# sourceMappingURL=card-wrapper.es.js.map
